import { SagaMiddleware } from 'redux-saga'

import * as cookieSagas from './features/cookie/saga'
import * as configurationsSaga from './features/configurations/saga'
import * as crewSagas from './features/crew/saga'
import * as vitalsSagas from './features/vitals/saga'
import * as homeSaga from './features/home/saga'
import * as cardiacArrestSagas from './features/quickActions/cardiacArrest/saga'
import * as validationSaga from './features/validation/saga'
import * as servicesSaga from './features/serviceSelection/saga'
import * as patientDemographicsSaga from './features/patientDemographics/saga'
import * as AuthorizationInformationSaga from './features/authorizationInformation/saga'
import * as timesSaga from './features/times/saga'
import * as searchSaga from './components/search/saga'
import * as dlScannerSaga from './features/driversLicenseScanner/saga'
import * as patientAllergiesSaga from './features/patientAllergies/saga'
import * as patientMedicalHistorySaga from './features/patientMedicalHistory/saga'
import * as patientMedicationSaga from './features/patientMedications/saga'
import * as singleSelectSaga from './components/singleSelectPage/saga'
import * as patientTimelineSaga from './features/timeline/saga'
import * as cardiacSaga from './features/procedures/cardiac/saga'
import * as addMedicationAdministeredSaga from './features/addMedicationAdministered/saga'
import * as quickActionsSaga from './features/quickActions/saga'
import * as intubationSaga from './features/intubation/saga'
import * as procedureSaga from './components/procedure/saga'
import * as optionsSaga from './features/options/saga'
import * as tripInformationSaga from './features/tripInformation/saga'
import * as pickupAddressSaga from './features/pickupAddress/saga'
import * as airwaySaga from './features/procedures/airway/saga'
import * as childbirthOBSaga from './features/procedures/childbirthOB/saga'
import * as initiateIvSaga from './features/procedures/initiateIv/saga'
import * as immobilizationSaga from './features/procedures/immobilization/saga'
import * as medicalConsultSaga from './features/procedures/medicalConsult/saga'
import * as extricationSaga from './features/procedures/extrication/saga'
import * as operationsSaga from './features/procedures/operations/saga'
import * as imagingUltrasoundSaga from './features/procedures/imagingUltrasound/saga'
import * as drainSaga from './features/procedures/drain/saga'
import * as rescueSaga from './features/procedures/rescue/saga'
import * as ventilatorSaga from './features/procedures/ventilator/saga'
import * as hospitalNotifySaga from './features/procedures/hospitalNotify/saga'
import * as woundCareSaga from './features/procedures/woundCare/saga'
import * as submitChartSaga from './features/submitChart/saga'
import * as signatureSaga from './features/signatures/saga'
import * as narrativeSaga from './features/narrative/saga'
import * as cadImportSaga from './features/cadImport/saga'
import * as ccHpiSaga from './features/ccHpi/saga'
import * as fluidsSaga from './features/fluids/saga'
import * as zipSaga from './components/zip/saga'
import * as destinationAddressSaga from './features/destinationAddress/saga'
import * as insuranceInformationSaga from './features/insuranceInformation/saga'
import * as relationshipsAndGuarantorsSaga from './features/relationshipsAndGuarantors/saga'
import * as pcsInformationSaga from './features/pcsInformation/saga'
import * as saveCmsInformationSaga from './features/cmsInformation/saga'
import * as savePaymentInformationSaga from './features/paymentInformation/saga'
import * as apiErrorHandlerSaga from './components/apiErrorHandler/saga'
import * as cmsInformationSaga from './features/cmsInformation/saga'
import * as paymentInformationSaga from './features/paymentInformation/saga'
import * as patientInformationSaga from './features/patientInformation/saga'
import * as patientSearchSaga from './features/patientSearch/saga'
import * as clientDataSaga from './features/clientData/saga'
import * as pcrSaga from './features/pcr/saga'
import * as cameraAttachmentsSaga from './features/cameraAttachments/saga'
import * as customSignatureSaga from './features/customSignature/saga'
import * as factorsAffectingCareSaga from './features/factorsAffectingCare/saga'
import * as sceneDescriptionSaga from './features/sceneDescription/saga'
import * as exposureSaga from './features/exposure/saga'
import * as titrateSaga from './features/procedures/titrate/saga'
import * as zollSupportTicketSaga from './features/zollSupportTicket/saga'
import * as initialAssessmentAirwaySaga from './features/initialAssessments/airway/saga'
import * as respiratorySaga from './features/initialAssessments/respiratory/saga'
import * as neuroSaga from './features/initialAssessments/neuro/saga'
import * as motorSensorySaga from './features/initialAssessments/neuro/motorSensoryAssessment/saga'
import * as pupilsSaga from './features/initialAssessments/neuro/pupils/saga'
import * as wasPatientImmobilizedSaga from './features/initialAssessments/neuro/wasPatientImmobilized/saga'
import * as glassgowCommaScoreSaga from './features/initialAssessments/neuro/glassgowCommaScore/saga'
import * as rtsSaga from './features/initialAssessments/neuro/revisedTraumaScore/saga'
import * as ptsSaga from './features/initialAssessments/neuro/pediatricTraumaScore/saga'
import * as pulsesSaga from './features/initialAssessments/cardio/pulses/saga'
import * as initialAssessmentCardioSaga from './features/initialAssessments/cardio/saga'
import * as initialAssessmentSaga from './features/initialAssessments/saga'
import * as completeChartSaga from './features/completeChart/saga'
import * as labsSaga from './features/procedures/labs/saga'
import * as pnProcedureSaga from './features/procedures/pnProcedure/saga'
import * as pnMedicationSaga from './features/procedures/pnMedication/saga'
import * as rulesSaga from './features/rules/saga'
import * as employerSaga from './features/patientDemographics/employer/saga'
import * as motorVehicleIncidentSaga from './features/ccHpi/motorVehicleIncident/saga'
import * as patientImmunizationSaga from './features/patientImmunizations/saga'
import * as ekgImportSaga from './features/ekgImport/saga'
import * as pulsaraSaga from './features/pulsara/saga'
import * as qaAddendumSaga from './features/qaFlags/qaAddendums/saga'
import * as notificationCenterSaga from './features/notificationCenter/saga'
import * as diagnosisSaga from './features/diagnosis/saga'
import * as drainsAndTubesSaga from './features/additionalAssessments/bodyAssessment/drainsTubes/saga'
import * as obstetricsSaga from './features/additionalAssessments/bodyAssessment/obstetrics/saga'
import * as burnsSaga from './features/additionalAssessments/bodyAssessment/burns/saga'
import * as bodySurveySaga from './features/additionalAssessments/bodyAssessment/bodySurvey/saga'
import * as assessmentsSaga from './features/additionalAssessments/saga'
import * as defaultsSaga from './features/defaults/saga'
import * as locationSearchSaga from './features/locationSearch/saga'
import * as documentScannerSaga from './features/documentScanner/saga'
import * as NemsisCustomDataSaga from './features/nemsisData/saga'
import * as BloodProductAdministrationSaga from './features/procedures/bloodProductAdministration/saga'
import * as ventricularAssistDeviceSaga from './features/procedures/ventricularAssistDevice/saga'
import * as criticalCareSaga from './features/procedures/criticalCare/saga'
import * as assessmentProcedureSaga from './features/procedures/assessment/saga'
import * as specialReportsSaga from './features/specialReports/saga'
import * as fillablePDFsSaga from './features/fillablePDFs/saga'
import * as sessionResumeSaga from './features/session/resume/saga'
import * as pcrBackupSaga from './features/pcrBackup/saga'

export const initSagas = (sagaMiddleWare: SagaMiddleware<SagaMiddleware>): void => {
  Object.values(cookieSagas).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(clientDataSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(configurationsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(crewSagas).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(vitalsSagas).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(homeSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(cardiacArrestSagas).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(validationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(servicesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientDemographicsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(AuthorizationInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(timesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientAllergiesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(searchSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(dlScannerSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientAllergiesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientMedicalHistorySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientMedicationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(singleSelectSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientTimelineSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(cardiacSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(addMedicationAdministeredSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(intubationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(procedureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(quickActionsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(optionsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(tripInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pickupAddressSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(airwaySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(childbirthOBSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(initiateIvSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(immobilizationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(medicalConsultSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(extricationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(operationsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(imagingUltrasoundSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(rescueSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(ventilatorSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(hospitalNotifySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(woundCareSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(submitChartSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(signatureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(narrativeSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(cadImportSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(ccHpiSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(fluidsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(zipSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(destinationAddressSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(insuranceInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(relationshipsAndGuarantorsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pcsInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(saveCmsInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(savePaymentInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(apiErrorHandlerSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(cmsInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(paymentInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientInformationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientSearchSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pcrSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(cameraAttachmentsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(customSignatureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(factorsAffectingCareSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(sceneDescriptionSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(exposureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(titrateSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(zollSupportTicketSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(initialAssessmentAirwaySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(respiratorySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(neuroSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(motorSensorySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pupilsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(wasPatientImmobilizedSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(glassgowCommaScoreSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(rtsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(ptsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pulsesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(initialAssessmentCardioSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(initialAssessmentSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(completeChartSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(drainSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(ekgImportSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pulsaraSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(qaAddendumSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(notificationCenterSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(labsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pnProcedureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pnMedicationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(rulesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(employerSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(motorVehicleIncidentSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(patientImmunizationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(diagnosisSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(drainsAndTubesSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(obstetricsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(burnsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(bodySurveySaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(assessmentsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(defaultsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(locationSearchSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(documentScannerSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(NemsisCustomDataSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(BloodProductAdministrationSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(ventricularAssistDeviceSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(criticalCareSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(assessmentProcedureSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(specialReportsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(fillablePDFsSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(sessionResumeSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
  Object.values(pcrBackupSaga).forEach(sagaMiddleWare.run.bind(sagaMiddleWare))
}
